import React from 'react';
import PropTypes from 'prop-types';
import Swiper from 'react-id-swiper';
import { get } from 'lodash';
import classNames from 'classnames';
import 'react-id-swiper/src/styles/css/swiper.css';

import uaDetector from 'rebook/apps/utils/uaDetector';

import styles from './style.scss';


class ContentCarousel extends React.Component {
  constructor(props) {
    super(props);
    this.swiper = null;
    this.state = {
      isEnd: false,
      isBeginning: true,
    };
  }

  goNext() {
    if (this.swiper) {
      if (this.swiper.isBeginning) {
        this.setState({ isBeginning: false });
      };
      this.swiper.slideNext();
      if (this.swiper.isEnd) {
        this.setState({ isEnd: true, isBeginning: false });
      };
    };
  }

  goPrev() {
    if (this.swiper) {
      if (this.swiper.isEnd) {
        this.setState({ isEnd: false });
      };
      this.swiper.slidePrev();
      if (this.swiper.isBeginning) {
        this.setState({ isEnd: false, isBeginning: true });
      };
    };
  }

  swipeHandler() {
    if (this.swiper) {
      this.setState({
        isEnd: this.swiper.isEnd,
        isBeginning: this.swiper.isBeginning,
      });
    };
  }

  componentWillReceiveProps() {
    if (this.swiper) {
      this.swiper.update();
    }
  }

  // http://idangero.us/swiper/api/
  render() {
    const params = {
      slidesPerView: 'auto',
      freeMode: true,
      lazy: true,
      wrapperClass: 'swiper-wrapper',
      containerClass: 'swiper-container',
      on: {
        slideChangeTransitionEnd: this.swipeHandler.bind(this),
      },
      spaceBetween: parseInt(this.props.spaceBetween, 10),
      slidesOffsetBefore: parseInt(this.props.slidesOffsetBefore, 10),
      slidesOffsetAfter: parseInt(this.props.slidesOffsetAfter, 10),
    };

    const { withNav, visibleElements, extraClassName } = this.props;
    const childrenCount = get(this.props, 'children.length', 0);
    const showArrows = window && window.navigator
      && !uaDetector.isMobile(window.navigator.userAgent)
      && withNav && childrenCount > visibleElements;

    return (
      <div className={classNames(styles.wrapper, extraClassName)}>
        <Swiper {...params} ref={(node) => { if (node) { this.swiper = node.swiper; }}}>
          {this.props.children}
        </Swiper>
        {showArrows && (
          <React.Fragment>
            <div className={classNames(styles.buttonPrev, { isHidden: this.state.isBeginning })}
              onClick={() => this.goPrev()}>
              <span className="arrowLeft" />
            </div>
            <div className={classNames(styles.buttonNext, { isHidden: this.state.isEnd })}
              onClick={() => this.goNext()}>
              <span className="arrowRight" />
            </div>
          </React.Fragment>
        )}
      </div>
    );
  }
};

ContentCarousel.propTypes = {
  spaceBetween: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  slidesOffsetBefore: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  slidesOffsetAfter: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  visibleElements: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  withNav: PropTypes.bool,
  extraClassName: PropTypes.string,
};

ContentCarousel.defaultProps = {
  spaceBetween: 0,
  slidesOffsetBefore: 0,
  slidesOffsetAfter: 0,
  withNav: true,
  visibleElements: 6,
  extraClassName: '',
};

export default ContentCarousel;
